import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Domains that Attain delivers in, to be connected to Organizations, Offerings, Projects, and Proposals',
    name: 'Domains',
    partialId: PartialId.Standard.create('domains'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
